module.exports = require("vue-client-only");